module.exports = __webpack_public_path__ + "media/stylesheets/images/start-54a789d8a26d39317d807e7fb1275a1f.svg";